module.exports = __webpack_public_path__ + "static/media/seethemes.978c99f2.svg";